module.exports = __webpack_public_path__ + "static/media/loader-metronome-0.8-speed.9d70fce5.gif";